class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static freeShippingText = window.free_shipping_text.free_shipping_message;
    static freeShippingText1 = window.free_shipping_text.free_shipping_message_1;
    static freeShippingText2 = window.free_shipping_text.free_shipping_message_2;
    static freeShippingText3 = window.free_shipping_text.free_shipping_message_3;
    static freeShippingText4 = window.free_shipping_text.free_shipping_message_4;
    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';
    static freeshipPrice = parseInt(window.free_shipping_price);

    connectedCallback() {
        this.freeShippingEligible = 0;
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
        this.shipVal = window.free_shipping_text.free_shipping_1;
        this.progressMeter = this.querySelector('[ data-free-shipping-progress-meter]');

        this.addEventListener('change', this.onCartChange.bind(this));

        this.initialize();
    }

    initialize() {
        Shopify.getCart((cart) => {
            this.cart = cart;
            this.calculateProgress(cart);
        })
    }

    onCartChange(e) {
        this.initialize();
    }

    calculateProgress(cart) {
        this.freeShippingEligible = 0;
        const cartTotalPrice = parseInt(cart.total_price) / 100;
        let freeShipBar = Math.round((cartTotalPrice * 100) / FreeShippingMeter.freeshipPrice);
        if (freeShipBar >= 100) {
            freeShipBar = 100;
        }
        
        const text = this.getText(cartTotalPrice, freeShipBar);
        const classLabel = this.getClassLabel(freeShipBar);

        this.setProgressWidthAndText(freeShipBar, text, classLabel);
        this.updateShippingCost(cart);
    }

    // Shipping cost line (snippets/free-shipping-component.liquid): kept in sync with the cart, since the drawer does not re-render this component.
    updateShippingCost(cart) {
        const shippingCost = this.querySelector('[data-shani-shipping-cost]');
        if (!shippingCost) return;
        const isFree = parseInt(cart.total_price) >= parseInt(shippingCost.dataset.freeFrom);
        shippingCost.textContent = isFree ? shippingCost.dataset.textFree : shippingCost.dataset.textPaid;
        // Round 5b: this line stays hidden here; the shipping line lives in the totals block (data-shani-ship-row), above the total.
        shippingCost.hidden = true;
        document.querySelectorAll('[data-shani-ship-row]').forEach((row) => {
            const rowFree = parseInt(cart.total_price) >= parseInt(row.dataset.freeFrom || shippingCost.dataset.freeFrom);
            const val = row.querySelector('[data-shani-ship-val]');
            if (val) val.textContent = rowFree ? row.dataset.textFree : row.dataset.textPaid;
            row.classList.toggle('is-free', rowFree);
            row.hidden = cart.item_count == 0;
        });
        // Round 5c: the total lives inside the checkout button ("לתשלום · X ₪"), items after discounts, same money format as the theme.
        document.querySelectorAll('[data-shani-pay-total]').forEach((el) => {
            // Round 6: same markup as snippets/shani-money (number right, ₪ left in any browser). Fallback if the helper is missing.
            if (window.shaniMoneyNode) el.replaceChildren(window.shaniMoneyNode(cart.total_price));
            else el.textContent = Shopify.formatMoney(cart.total_price, window.money_format);
        });
    }

    getText(cartTotalPrice, freeShipBar) {
        let text;

        if (cartTotalPrice == 0) {
            this.progressBar.classList.add('progress-hidden');
            const emptyBefore = this.shaniText('textEmptyBefore');
            text = emptyBefore
                ? '<span>' + emptyBefore + Shopify.formatMoney(FreeShippingMeter.freeshipPrice * 100, window.money_format) + '</span>'
                : '<span>' + FreeShippingMeter.freeShippingText + ' ' + Shopify.formatMoney(FreeShippingMeter.freeshipPrice * 100, window.money_format) +'!</span>';
        } else if (cartTotalPrice >= FreeShippingMeter.freeshipPrice) {
            this.progressBar.classList.remove('progress-hidden');
            this.freeShippingEligible = 1;
            // Shani copy (07-microcopy-omer v4.1 §6) lives on the component's data-* attributes; theme strings are the fallback.
            text = this.shaniText('textReached') || FreeShippingMeter.freeShippingText1;
        } else {
            this.progressBar.classList.remove('progress-hidden');
            // Remaining rounded UP to a whole shekel: parseInt used to cut 0.20 down to 0 (198.80 cart showed "0").
            const remainingCents = Math.round((FreeShippingMeter.freeshipPrice - cartTotalPrice) * 100);
            const remainingPrice = Math.ceil(remainingCents / 100);
            const gapBefore = this.shaniText('textGapBefore');
            const gapAfter = this.shaniText('textGapAfter');
            if (gapBefore && gapAfter) {
                text = '<span>' + gapBefore + ' </span>' + Shopify.formatMoney(remainingPrice * 100, window.money_format) + '<span class="text"> ' + gapAfter + '</span>';
            } else {
                text = '<span>' + FreeShippingMeter.freeShippingText2 + ' </span>' + Shopify.formatMoney(remainingPrice * 100, window.money_format) + '<span> ' +  FreeShippingMeter.freeShippingText3 + ' </span><span class="text">' + FreeShippingMeter.freeShippingText4 + '</span>';
            }
            this.shipVal = window.free_shipping_text.free_shipping_2;
        }

        return text;
    }

    shaniText(key) {
        const el = this.querySelector('[data-shani-shipping-cost]');
        return el ? (el.dataset[key] || '') : '';
    }

    getClassLabel(freeShipBar) {
        let classLabel;

        if (freeShipBar === 0) {
            classLabel = 'none';
        } else if (freeShipBar <= 30) {
            classLabel = FreeShippingMeter.classLabel1;
        } else  if (freeShipBar <= 60) {
            classLabel = FreeShippingMeter.classLabel2;
        } else if (freeShipBar <= 100) {
            classLabel = FreeShippingMeter.classLabel3;
        } else {
            classLabel = 'progress-free'
        }

        return classLabel;
    }
    
    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('progress-30');
        this.progressBar.classList.remove('progress-60');
        this.progressBar.classList.remove('progress-100');
        this.progressBar.classList.remove('progress-free');

        this.progressBar.classList.add(classLabel);
    }
    
    setProgressWidthAndText(freeShipBar, text, classLabel) {
        setTimeout(() => {
            this.resetProgressClass(classLabel);

            this.progressMeter.style.width = `${freeShipBar}%`;
            if (this.textEnabled) {
                const textWrapper = this.progressMeter.querySelector('.text').innerHTML = `${freeShipBar}%`;
            }

            this.messageElement.innerHTML = text;
            this.messageElement.classList.toggle('shani-reached', this.freeShippingEligible === 1);

            if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
                Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
            }
        }, 400)
    }
}

window.addEventListener('load', () => {
    customElements.define('free-shipping-component', FreeShippingMeter);
})